import React from 'react';
import {connect} from 'react-redux';
import _ from "lodash";

import CheckBox from "../CheckBox";
import {setDocuSignPopupState} from "../../../actions/A_Popups";
import {messageBoxEx_Show} from "../../../actions";

class DocuSignPopup extends React.Component {

  closePopup = () => {
    this.props.setDocuSignPopupState({
      showPopup: false
    })
  };

  changeDocuSignInfo = (e) => {
    this.props.setDocuSignPopupState({
      [e.target.name]: e.target.value
    })
  };

  changeProductionMode = () => {
    this.props.setDocuSignPopupState({
      ds_isProduction: !this.props.docuSignPopupState.ds_isProduction
    })
  };

  saveDocuSign = () => {
    let errors = [];
    const {ds_sandBoxUserId, ds_sandBoxAuthToken, ds_prodClientId, ds_prodUserId, ds_prodPrivateKey,
      ds_checkOutContractId, ds_isProduction} = this.props.docuSignPopupState;
    if (!ds_isProduction) {
      if (_.trim(ds_sandBoxUserId).length === 0) {
        errors.push("Sandbox User Id is required when using Sandbox mode.");
      }
      if (_.trim(ds_sandBoxAuthToken).length === 0) {
        errors.push("Sandbox Access Token is required when using Sandbox mode.");
      }
    } else {
      if (_.trim(ds_prodClientId).length === 0) {
        errors.push("Production Client Id is required when using Production mode.");
      }
      if (_.trim(ds_prodUserId).length === 0) {
        errors.push("Production User Id is required when using Production mode.");
      }
      if (_.trim(ds_prodPrivateKey).length === 0) {
        errors.push("Production Private Key is required when using Production mode.");
      }
    }
    if (_.isEmpty(_.trim(ds_checkOutContractId))) {
      errors.push('Checkout Template Id is required.');
    }

    if (errors.length > 0) {
      this.props.messageBoxEx_Show(true, 'error', 'Invalid/Missing DocuSign Information', errors.join('<br />'));
    } else {
      const docuSignObj = {
        sandBoxClientId: ds_sandBoxUserId,
        accessToken: ds_sandBoxAuthToken,
        isSandBox: !ds_isProduction,
        clientId: ds_prodClientId,
        impersonateUserGuid: ds_prodUserId,
        privateKey: ds_prodPrivateKey,
        isEnabled: this.props.formValues.enableDocuSign,
        docuSignTemplates: {
          checkOutContract: {
            id: ds_checkOutContractId
          }
        }
      };

      this.props.setDocuSignPopupState({
        docuSignObj: {...docuSignObj}
      })
      this.closePopup();
    }
  }

  render() {

    const {ds_sandBoxUserId, ds_sandBoxAuthToken, ds_prodClientId, ds_prodUserId, ds_prodPrivateKey,
      ds_checkOutContractId, ds_isProduction} = this.props.docuSignPopupState;

    const tokenGeneratorLink = "https://developers.docusign.com/oauth-token-generator";

    return (
      <div className="ui-popup ui-popup--small ui-popup--reset-font">
        <div className="ui-popup-header">
          <span className="ui-popup-header__text">Set DocuSign Parameters</span>
          <button className="ui-popup-header__close" onClick={this.closePopup}/>
        </div>
        <div className="ui-popup-body ui-popup-body--tiny">
          <div className="new-account-creditcard-overlay-body">
            <div className="field-row flex">
              <div className="flex-item" style={{flex: "0 0 35%"}}>
                <input className="label-jump" type="text" placeholder="SandBox User Id"
                       name="ds_sandBoxUserId" value={ds_sandBoxUserId} required
                       onChange={this.changeDocuSignInfo}/>
                <label>SandBox User Id</label>
              </div>
              <div className="flex-item">
                <input className="label-jump" type="text" placeholder="SandBox Authentication Token"
                       value={ds_sandBoxAuthToken} required name="ds_sandBoxAuthToken"
                       onChange={this.changeDocuSignInfo}/>
                {ds_sandBoxAuthToken ? <label>SandBox Authentication Token </label> : null}
                <a href="#" rel="external" onClick={() => window.open(tokenGeneratorLink,  '_blank')}>
                  Get it here
                </a>
              </div>
            </div>
            <div className="field-row flex">
              <div className="flex-item" style={{flex: "0 0 35%"}}>
                <input className="label-jump" type="text" placeholder="Production Client Id"
                       value={ds_prodClientId} required name="ds_prodClientId" onChange={this.changeDocuSignInfo}/>
                <label>Production Client id</label>
              </div>
              <div className="flex-item">
                <input className="label-jump" type="text" placeholder="Production User Id"
                       value={ds_prodUserId} required name="ds_prodUserId" onChange={this.changeDocuSignInfo}/>
                <label>Production User id</label>
              </div>
            </div>
            <div className="field-row" style={{height: "auto"}}>
              <textarea className="terms" placeholder="Production Private Key" value={ds_prodPrivateKey} required
                    name="ds_prodPrivateKey" onChange={this.changeDocuSignInfo}/>
              <label>Production Private Key</label>
            </div>
            <div className="field-row">
              <input className="label-jump" type="text" placeholder="CheckOut Template Id"
                     value={ds_checkOutContractId} required name="ds_checkOutContractId"
                     onChange={this.changeDocuSignInfo}/>
              <label>CheckOut Template Id</label>
            </div>
            <div style={{paddingLeft: "20px"}}>
              <CheckBox checked={ds_isProduction} text="Enable Production Mode" name="ds_isProduction"
                        onChecked={this.changeProductionMode}/>
            </div>
          </div>
        </div>
        <div className="ui-popup-footer">
          <button className="ui-button ui-button--blue" onClick={this.closePopup}>
            <span className="ui-button-text ui-button--uppercase">Cancel</span>
          </button>
          <button className="ui-button ui-button--green" onClick={this.saveDocuSign}>
            <span className="ui-button-text ui-button--uppercase">Save</span>
          </button>
        </div>
      </div>
    )
  }

}

const mapStateToProps = (store) => {
  return {
    docuSignPopupState: store.popups.docuSignPopupState,
    formValues: (store.form && store.form.newEntity && store.form.newEntity.values) || {}
  };
};

const mapDispatchToProps = {
  setDocuSignPopupState,
  messageBoxEx_Show
};

export default connect(mapStateToProps, mapDispatchToProps)(DocuSignPopup);
